import React, { FC } from "react";
import { Outlet } from "react-router-dom";

const EmptyLayout: FC = () => (
	<div
		style={{
			minHeight: "100vh",
			display: "flex",
			flexWrap: "wrap",
			flexDirection: "column",
		}}
	>
		<div
			style={{
				width: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flex: 1,
			}}
		>
			<Outlet />
		</div>
	</div>
);

export default EmptyLayout;
